import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
	name: "initials",
	standalone: true,
})
export class InitialsPipe implements PipeTransform {
	transform(value: string | undefined | null): string {
		if (!value) return "";

		// Split by space and filter out any double-space empty strings
		const names = value.trim().split(/\s+/);

		if (names.length === 0) return "";

		// Take the first 2 names
		const firstTwo = names.slice(0, 2);

		// Map to first character and join
		return firstTwo.map((name) => name.charAt(0).toUpperCase()).join("");
	}
}
